import { List } from "./list";
import { cr } from "fire-wind-water";

class Select extends List {
  constructor(field) {
    super(field);
    this.displaySelectType = "SELECT";
    this.messages.otherValue = "选项填空不能为空";
  }

  setValue(id?: { [label: string]: any }): void {
    const val = this.listOptions.filter((d) => {
      return d.optionId === id;
    })[0];
    this.value = val ? [val.optionValue] : [];
    this.label = val ? [val.optionId] : [];
    this.model = val || [];
    this.otherValue = [];
    if (val && val.otherisFillIn == 1) {
      this.otherValue.push({ [val.optionValue]: val.otherValue });
    }
    cr.each(this.listOptions, (d) => {
      d.checked = this.value.indexOf(d.optionValue) !== -1;
    });
    this.dirty = true;
    this.isError();
  }

  setManyOptions(): void {
    const data = cr.extend(true, [], this.listOriginal);
    const list = [data[0]];
    for (let i = 1; i < this.model.length; i++) {
      const lrr = data[i].filter((d) => {
        return d.parentId && d.parentId == this.model[i - 1].optionId;
      });
      list.push(lrr);
    }
    if (this.value.length > 0 && data[this.value.length]) {
      const arr = data[this.value.length].filter((d) => {
        return (
          d.parentId && d.parentId == this.model[this.model.length - 1].optionId
        );
      });
      list.push(arr);
    }
    const ls: any = {};
    list.forEach((d, i) => {
      if (!ls[i]) {
        ls[i] = [];
      }
      d.map((m) => {
        ls[i].push(m.optionId);
        m.checked = m.optionValue === this.value[i];
      });
    });
    this.setListOptions(list);

    cr.each(this.listOriginal, (d, i) => {
      cr.each(d, (o) => {
        if (i > 0) {
          if (ls[i]) {
            o.isNotShow = ls[i].indexOf(o.optionId) === -1 ? 1 : 0;
          } else {
            o.isNotShow = 1;
          }
        } else {
          o.isNotShow = 0;
        }
      });
    });
  }

  setManyValue(o): void {
    if (this.value.length < o.index) {
      console.error("Fuck, how did the data come from");
    }
    const n = this.value.length;
    this.value.splice(o.index, n);
    this.label.splice(o.index, n);
    this.model.splice(o.index, n);
    this.value.push(o.optionValue);
    this.label.push(o.optionId);
    this.model.push(o);
    this.setManyOptions();
    this.isError();
  }

  clearValue(): void {
    super.clearValue();
    if (this.isCascade === 1) {
      this.setManyOptions();
    }
  }
}

export { Select };
